import { BROWN } from "@/utils/constants/colors-constants.ts"
import type GeneralSvgProps from "@/utils/types/sgv/general-svg-props.ts"

export const MyApiaryIcon: React.FC<GeneralSvgProps> = (props) => {
  return (
    <svg
      {...props}
      width={props.size || 30}
      height={props.size || 27}
      viewBox="0 0 30 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.95495 4.37528L15.2332 0.750555L21.5114 4.37528V11.6247L15.2332 15.2494L8.95495 11.6247V4.37528Z"
        stroke={props.is_active ? BROWN : "#414141"}
        strokeWidth="1.5"
      />
      <path
        d="M2.55505 14.8752L8.83325 11.2505L15.1115 14.8752V22.1247L8.83325 25.7494L2.55505 22.1247V14.8752Z"
        stroke={props.is_active ? BROWN : "#414141"}
        strokeWidth="1.5"
      />
      <path
        d="M15.555 14.8752L21.8333 11.2505L28.1115 14.8752V22.1247L21.8333 25.7494L15.555 22.1247V14.8752Z"
        stroke={props.is_active ? BROWN : "#414141"}
        strokeWidth="1.5"
      />
    </svg>
  )
}
